export const FLAG_DOCPLANTAO = 'Docplantão'
